import { Col, Divider, Form, FormInstance, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { CheckboxGroupButtons } from '@/components/_common';
import ReportWorkOrderFilterByDateField from './ReportWorkOrderFilterByDateField';
import ReportWorkOrderSituationField from './ReportWorkOrderSituationField';
import MoreOptionsWorkOderReport from './MoreOptionsWorkOrderReport';
import {
  QuestFilterByWorkOrderType,
  QuestReportOrderBy,
  QuestReportType,
  QuestWorkOrderReportFormValues,
} from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';
import ReportWorkOrderOptionsFields from './ReportWorkOrderOptionsFields';

import './style.less';
import { isAppPortocar } from '@/index';

interface Props {
  form: FormInstance<QuestWorkOrderReportFormValues>;
}

const WorkOrdersReportForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Title } = Typography;

  const reportType = Form.useWatch('reportType', form);
  const isSynthetic = Form.useWatch('isSynthetic', form);
  const isSyntheticGrouped = Form.useWatch('isSyntheticGrouped', form);
  const isTotalPerWorkOrder = reportType === QuestReportType.totalPerWorkOrder;

  const workOrderTypeOptions = [
    {
      label: intl.formatMessage({
        id: 'movementWorkOrdersReport.form.budgetType.budget',
      }),
      value: QuestFilterByWorkOrderType.workOrder,
    },
    {
      label: intl.formatMessage({
        id: 'movementWorkOrdersReport.form.budgetType.assurance',
      }),
      value: QuestFilterByWorkOrderType.warranty,
    },
    {
      label: intl.formatMessage({
        id: 'movementWorkOrdersReport.form.budgetType.return',
      }),
      value: QuestFilterByWorkOrderType.return,
    },
    {
      label: intl.formatMessage({
        id: `movementWorkOrdersReport.form.budgetType.${
          isAppPortocar ? 'insideCourtesy' : 'courtesy'
        }`,
      }),
      value: QuestFilterByWorkOrderType.courtesy,
    },
    {
      label: intl.formatMessage({
        id: 'movementWorkOrdersReport.form.budgetType.totalLoss',
      }),
      value: QuestFilterByWorkOrderType.totalLoss,
    },
    {
      label: intl.formatMessage({
        id: 'movementWorkOrdersReport.form.budgetType.revision',
      }),
      value: QuestFilterByWorkOrderType.revision,
    },
  ];

  return (
    <Form layout="vertical" form={form} className="work-orders-report-form">
      <ReportSelectMonthFields
        form={form}
        dateFilter={<ReportWorkOrderFilterByDateField />}
      />

      <Row gutter={[12, 12]}>
        <Col sm={24}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.selectReportType',
            })}
          </Title>

          <Form.Item
            name="reportType"
            noStyle
            initialValue={QuestReportType.totalPerWorkOrder}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={QuestReportType.totalPerWorkOrder}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.totalPerBudget',
                })}
              </Radio>

              <Radio value={QuestReportType.insurerPrivate}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.insurerAndPrivate',
                })}
              </Radio>

              <Radio value={QuestReportType.estimators}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.estimators',
                })}
              </Radio>

              <Radio value={QuestReportType.servicesAndPartsPerVehicle}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.ServicesAndPartsPerVehicle',
                })}
              </Radio>

              <Radio value={QuestReportType.workOrderCost}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.osCost',
                })}
              </Radio>

              <Radio value={QuestReportType.partStatus}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.partStatus',
                })}
              </Radio>

              <Radio value={QuestReportType.workOrderPerArea}>
                {intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.selectReportType.osByArea',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        {!isSynthetic && !isSyntheticGrouped && isTotalPerWorkOrder && (
          <Col sm={24}>
            <Title level={5}>Ordenar por</Title>

            <Form.Item
              name="orderBy"
              noStyle
              initialValue={QuestReportOrderBy.situation}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={QuestReportOrderBy.situation}>Situação</Radio>

                <Radio value={QuestReportOrderBy.entryDate}>
                  Data de entrada
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        )}

        <ReportWorkOrderSituationField />

        <Col span={24} md={24} lg={18} xxl={13}>
          <Title level={5}>
            {intl.formatMessage({
              id: 'movementWorkOrdersReport.form.budgetType',
            })}
          </Title>

          <Form.Item
            name="filterByWorkOrderType"
            initialValue={[QuestFilterByWorkOrderType.workOrder]}
          >
            <CheckboxGroupButtons options={workOrderTypeOptions} />
          </Form.Item>
        </Col>

        {reportType === QuestReportType.workOrderCost && (
          <Col span={24} md={24} lg={8} xl={6} xxl={6}>
            <Title level={5}>Selecione o tipo de cálculo</Title>

            <Form.Item name="commissionByLiquidValue" initialValue="false">
              <Radio.Group buttonStyle="solid" optionType="button" size="large">
                <Radio value="false">Valor Base</Radio>

                <Radio value="true">Valor Líquido</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        )}

        <ReportWorkOrderOptionsFields />

        <Divider />

        {!isSyntheticGrouped && <MoreOptionsWorkOderReport form={form} />}
      </Row>
    </Form>
  );
};

export default WorkOrdersReportForm;
